import { useMemo } from "react";

import { useDataLayerQuery } from "#/hooks/useDataLayer";
import { BreedingValuesComparisonRankService } from "#/pages/breeding-values/BreedingValuesComparisonRankService";

/**
 * Custom hook for Breeding Values Comparison Rank Query.
 * Uses the BreedingValuesComparisonRankService to perform POST queries.
 *
 * @returns {object} The data layer query object (result, isLoading, error, query, reload).
 */
export function useBreedingValuesComparisonRankQuery() {
  const service = useMemo(() => new BreedingValuesComparisonRankService(), []);

  return useDataLayerQuery({
    ident: "breeding-values-comparison-rank",
    dataLayer: service,
  });
}
